export default [
  'fetch_students@list',
  'fetch_student@single',
  'add_credits@credits',
  'remove_student',
];
